import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';

const EnvironmentWrapper = ({
  authedNode = null,
  publicNode = null
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);
  return isAppAuth ? /*#__PURE__*/_jsx(_Fragment, {
    children: authedNode
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: publicNode
  });
};

export default EnvironmentWrapper;